// Stores

import create, { State, StateCreator, UseStore } from 'zustand';
import { devtools } from 'zustand/middleware';

import { createAppState } from './app';
import { createAuthState } from './auth';
import { createCampaignState } from './campaignsStore';
import { createTemplateState } from './templatesStore';

function createStore<TState extends State>(createState: StateCreator<TState>, name: string): UseStore<TState> {
  return create(devtools(createState, name));
}

export function resetStores() {
  useTemplatesStore.getState().resetTemplates();
  useCampaignsStore.getState().resetCampaigns();
}

export const useAppStore = createStore(createAppState, 'AppStore');
export const useAuthStore = createStore(createAuthState, 'AuthStore');
export const useTemplatesStore = createStore(createTemplateState, 'TemplatesStore');
export const useCampaignsStore = createStore(createCampaignState, 'CampaignsStore');
